import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ViewProfileLayer from "../components/ViewProfileLayer";
import BusinessProfileLayer from "../components/BusinessProfileLayer";


const ViewBusinessProfile = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Business Profile" />

        {/* ViewProfileLayer */}
        <BusinessProfileLayer />

      </MasterLayout>

    </>
  );
};

export default ViewBusinessProfile; 
